





























































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import Avatar from 'vue-avatar';

@Component({
  name: 'ChatMenu',
  components: {
    Avatar,
  },
})
export default class ChatMenu extends Vue {
  @Prop() chatMenuData;
  @Prop() isChatDataPresent;
  @Prop() chatFilterType;

  private searchString: string = '';
  private chattingData: object = {};
  private candidateId: number = 18222;
  private participant: object = {};
  private jobData: object = {};
  private selectedGuidList: Array<string> = [];
  get chatOperation() {
    return [{
      "text": "Mark as read",
      "icon": "fa fa-envelope-open-o",
      "enable": true,
      "status": 55
    }, {
      "text": "Archive",
      "icon": "fa fa-archive",
      "enable": true,
      "status": 10
    }, {
      "text": "Delete",
      "icon": "fa fa-trash",
      "enable": true,
      "status": 99
    }]
  }
  get searchOperation() {
    return {
      showChatSearchIcon: true,
      showChatFilterIcon: true,
    };
  }

  get userId(){
    return vxm.users.myUserProfile.userId;
  }

  get companyCode(){
    return vxm.users.getCompanyCode;
  }

  async fetchUserConversation(converstsnGUID: any) {
    console.log(converstsnGUID, 'INDEX');
    try {
      let chatData = await vxm.jobs.fetchConversation({
        isAdmin: false,
        conversationGUID: converstsnGUID,
        adminId: this.userId,
      });
      this.chattingData = chatData;
      this.$emit('user-chating-data', chatData);
      this.$emit('candidate-conversation', true);
    } catch (error) {
      let response = {
        success: false,
      };
      this.$emit('user-chating-data', response);
      this.$emit('candidate-conversation', false);
    }
  }

  participantData(activeConversationsParticipants: number[]) {
    let self = this;
    if (activeConversationsParticipants && self.chatMenuData.participants) {
      for (let i = 0; i < activeConversationsParticipants.length; i++) {
        if (activeConversationsParticipants[i] !== this.userId) {
          for (let j = 0; j < self.chatMenuData.participants.length; j++) {
            if (
              activeConversationsParticipants[i] ===
              self.chatMenuData.participants[j].participantId
            ) {
              self.participant = self.chatMenuData.participants[j];
              break;
            }
          }
        }
      }
    }
  }

  getFormatedDate(date: number) {
    var convertedDate = new Date(date);
    var todayDate = new Date();
    if (
      convertedDate.getDate() == todayDate.getDate() &&
      convertedDate.getMonth() == todayDate.getMonth() &&
      convertedDate.getFullYear() == todayDate.getFullYear()
    ) {
      return 'Today';
    }
    var dd = convertedDate.getDate();
    var mm = convertedDate.getMonth() + 1;
    var yyyy = convertedDate.getFullYear().toString();
    var formatedDate = '';
    var formatedMonth = '';
    if (dd < 10) {
      formatedDate = '0' + dd;
    } else {
      formatedDate = dd.toString();
    }

    if (mm < 10) {
      formatedMonth = '0' + mm;
    } else {
      formatedMonth = mm.toString();
    }
    return formatedDate + '/' + formatedMonth + '/' + yyyy;
  }

  async searchFilter(searchData: String) {
    console.log('searchData------------>', searchData);
    if (searchData && searchData !== '') {
      this.chatMenuData = await vxm.jobs.searchClaimableConversations({
        archieve: 0,
        isAdmin: false,
        userId: this.userId,
        companyCode: this.companyCode,
        pageNumber: 1,
        pageSize: 10,
        filter: this.searchString,
        unreadChats: false,
      });
      if (this.chatMenuData && this.chatMenuData.activeConversations) {
        try {
          let chatData = await vxm.jobs.fetchConversation({
            isAdmin: true,
            conversationGUID: this.chatMenuData.activeConversations[0]
              .conversationGUID,
            adminId: this.userId,
          });
          this.chattingData = chatData;
          this.$emit('user-chating-data', chatData);
          this.$emit('candidate-conversation', true);
          this.$emit('chat-menu-response-data', this.chatMenuData);
        } catch (error) {
          let response = {
            success: false,
          };
          this.$emit('user-chating-data', response);
          this.$emit('candidate-conversation', false);
        }
      }
    }
  }

  loadChat(status){
    vxm.jobs.setActiveConversationGUID("");
    console.log("filtering chat with status", status);
    this.$emit('reload-chating-data', status);
  }

  async bulkOperation(actionStatus: String, conversationGUIDList: Array<string>){
    console.log('actionStatus-------->', actionStatus);
    console.log('conversationGUID-------->', conversationGUIDList);
    try {
      await vxm.jobs.conversationsAction({
        conversationGUIDList: conversationGUIDList,
        status: actionStatus,
      });
      if(this.chatFilterType=='ACTIVE'){
        this.$emit('reload-chating-data', 20);
      }else if(this.chatFilterType=='ARCHIVED'){
        this.$emit('reload-chating-data', 10);
      }else if(this.chatFilterType=='UNREAD'){
        this.$emit('reload-chating-data', 55);
      }
    } catch (error) {
      console.log('Error in candidateConversationsAction method: ', error);
    }
  }

  async candidateConversationsAction(
    actionStatus: String,
    conversationGUID: String,
  ) {
    console.log('actionStatus-------->', actionStatus);
    console.log('conversationGUID-------->', conversationGUID);
    try {
      await vxm.jobs.conversationsAction({
        conversationGUIDList: [conversationGUID],
        status: actionStatus,
      });
      if(this.chatFilterType=='ACTIVE'){
        this.$emit('reload-chating-data', 20);
      }else if(this.chatFilterType=='ARCHIVED'){
        this.$emit('reload-chating-data', 10);
      }else if(this.chatFilterType=='UNREAD'){
        this.$emit('reload-chating-data', 55);
      }
    } catch (error) {
      console.log('Error in candidateConversationsAction method: ', error);
    }
  }
}
